function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.3881 13.718L13.8059 13.709C13.4645 13.709 13.1307 13.7406 12.8013 13.7842L20.143 21.3323L12.709 28.9825H34.0919V21.7384C34.0919 17.6873 31.0202 13.718 26.3881 13.718L26.3881 13.718Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.9461 6.07175C25.9461 9.1653 23.2107 11.6728 19.8375 11.6728C16.4627 11.6728 13.7273 9.16533 13.7273 6.07175C13.7273 2.9782 16.4627 0.472168 19.8375 0.472168C23.2107 0.472168 25.9461 2.97817 25.9461 6.07175Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.48382 14.9963L8.20831 13.709H2.55935L5.18811 16.3592L6.85678 18.0435L8.08504 19.2826H-0.528076L-0.526552 23.4105H8.05301L6.02925 25.4509L5.16977 26.3202L2.53036 28.9825H8.17933L15.7637 21.3279L9.48382 14.9963Z",
  fill: "black"
});

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 29,
    viewBox: "0 0 34 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.25e895d9.svg";
export { ForwardRef as ReactComponent };